import React from 'react';
import {Link} from '@forecast-it/design-system';
import {FormattedMessage} from 'react-intl';

const REVENUE_URL =
	'https://support.forecast.app/hc/en-us/articles/39100086024337-Upcoming-Updates-to-Financial-Categories-Revenue-Calculations';
const RevenueLink = (): React.JSX.Element => {
	return (
		<Link target={'_blank'} href={REVENUE_URL}>
			<FormattedMessage id="common.help_center" />
		</Link>
	);
};

const REVENUE_RECOGNITION_URL =
	'https://support.forecast.app/hc/en-us/articles/4777848294289-Understanding-and-using-Revenue-Recognition';
const RevenueRecognitionLink = (): React.JSX.Element => {
	return (
		<Link target={'_blank'} href={REVENUE_RECOGNITION_URL}>
			<FormattedMessage id="common.help_center" />
		</Link>
	);
};

export const HelpCenterLinks = {
	Revenue: RevenueLink,
	RevenueRecognition: RevenueRecognitionLink,
};
